export default "__VITE_ASSET__DhHFHBHS__"